export default {
  update(context, error) {
    context.commit('SET_ERROR', error);
    if (error.snackbarMessage) {
      this.dispatch(`snackbar/update`, {
        text: error.snackbarMessage,
        color: `warning`,
        open: true,
        timeout: 10000
      });
    }
  },
  reset(context) {
    context.commit('RESET_ERROR');
  }
};
